globalThis.backoffice = globalThis.backoffice || {};

backoffice.AttachedFilesUploader = (function() {

  function AttachedFilesUploader($html) {
    if($html.length) {
      this.$html = $html;
      this.init();
    }
  }

  AttachedFilesUploader.prototype = {
    init: function() {
      this.initUploaders();
    },
    initUploaders: function() {
      var me = this;
      this.$html.find('.uploader-container').each(function() {
        me.initUploader($(this));
      });
    },
    initUploader: function($container) {
      var $button = $container.find('button'),
          uploader = new Uploader(this.$html, {
            data: ($container.data('additional-data') || {}),
            containers: {
              button: $container
            },
            progress: {
              percent: ".upload-percent",
              progressbar: '.upload-progressbar-inner'
            },
            plupload: {
              browse_button: $button[0],
              max_file_size: '100mb',
              multi_selection: true,
              url: this.$html.data('url'),
              filters : {
                mime_types : [
                  { title : 'Fichiers', extensions : $container.data('extensions') }
                ]
              }
            },
            callbacks: {
              filesAdded: function(up, files) {
                this.view.find('.files-total').text(files.length)
                         .closest('.upload-progress').show();
              },
              uploadProgress: function(up, file) {
                this.view.find(this.config.progress.progressbar).css('width', file.percent + '%')
                         .end()
                         .find(this.config.progress.percent).text(file.percent + '%')
              },
              fileUploaded: function(up, file, response) {
                if(response.response) {
                  var $file_index = this.view.find('.file-index'),
                      $html = $(response.html);

                  if(response.is_image) {
                    $('.images').prepend($html);
                  } else {
                    $('.files table tbody').prepend($html);
                  }

                  $file_index.text(parseInt($file_index.text()) + 1);
                  this.view.find(this.config.progress.progressbar).css('width', 0)
                           .end()
                           .find(this.config.progress.percent).text('0%');
                } else {
                  alert('Une erreur s\'est produite');
                }
              },
              uploadComplete: function(uploader, files) {
                this.view.find('.upload-progress').hide()
                         .find('.file-index').text('0')
                         .end()
                         .find(this.config.progress.percent).text('0%');
              }
            }
          });
    }
  }

  return AttachedFilesUploader;
})();
